import api from './api';

class AuthService {
  // Login admin user
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials);
      const { token, refreshToken, admin } = response.data.data;
      
      // Store tokens
      localStorage.setItem('adminToken', token);
      if (refreshToken) {
        localStorage.setItem('adminRefreshToken', refreshToken);
      }
      
      return { admin, token };
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Logout admin user
  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Continue with logout even if API call fails
      console.error('Logout API error:', error);
    } finally {
      // Always clear local storage
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminRefreshToken');
    }
  }

  // Get current admin profile
  async getProfile() {
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        throw new Error('No admin token found');
      }
      
      // Use the actual profile endpoint
      const response = await api.get('/profile');
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error('Profile fetch failed');
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Update admin profile
  async updateProfile(data) {
    try {
      const response = await api.put('/auth/profile', data);
      return response.data.admin;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Change password
  async changePassword(data) {
    try {
      const response = await api.put('/auth/password', data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Check if user is authenticated
  isAuthenticated() {
    return !!localStorage.getItem('adminToken');
  }

  // Get stored token
  getToken() {
    return localStorage.getItem('adminToken');
  }

  // Handle API errors
  handleError(error) {
    if (error.response?.data?.message) {
      return new Error(error.response.data.message);
    } else if (error.message) {
      return new Error(error.message);
    } else {
      return new Error('An unexpected error occurred');
    }
  }
}

export default new AuthService();